module.exports = __webpack_public_path__ + "static/media/ic_collapse_arrow.bb0f85ef.svg";